import * as React from 'react';

export const ArrowRounded = (
  <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='40' height='40' rx='20' fill='#50555B' />
    <path d='M23.96 28L16 20.02L24 12' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
